﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as bootstrap_switch from 'bootstrap-switch';

import tpl_htmlSingle from './tpl/htmlSingle.html';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import helper_infopage from '../../helper/infopage';
import View_Module from './module';
import View_ModuleItem from './moduleItem';

import config from '../../../common/config';


export default View_ModuleItem.extend({
    regions: {
        'modal': '#modal'
    },
    getTemplate: function () {
        return tpl_htmlSingle();
    },
    playLive: function () {
    },
    initialize: function () {
        var self = this;
        this.app = this.options.app;

        this.listenTo(this.model, 'setupSetting', this.setupSetting, this);

        var userChannel = Backbone.Radio.channel('app');
        this.listenTo(userChannel, 'HtmlSingle:getModuleData', function (moduleDiv, moduleRegion) {
            if (self.model.attributes.ModuleDiv == moduleDiv && self.model.attributes.ModuleRegion == moduleRegion) {
                var result = self.model.attributes.Data.Collection.filter(Selected => true)[0];
                if (self.ckeditor != undefined) {
                    result.Data = self.ckeditor.getData();
                }
            }
        });
        //this.listenTo(userChannel, 'module:getModuleData_htmlSingle', function (moduleDiv, moduleRegion ) {
        //    if (self.model.attributes.ModuleDiv == moduleDiv && self.model.attributes.ModuleRegion == moduleRegion) {
        //        var result = self.model.attributes.Data.Collection.filter(Selected => true)[0];
        //        result.Data = self.ckeditor.getData();
        //    }
        //});
    },
    ui: {
        'setting_margin': '#setting_margin',
        'module_margin': '#module_margin',
        'htmlSingle': '#htmlSingle',
        'editor': '#editor'
    },
    events: {
    },
    onRender: function () {
        this.setupSetting();
    },
    setAnimation: function (className) {
        this.ui.htmlSingle.show();
        this.ui.htmlSingle.addClass(className);
        this.ui.htmlSingle.addClass('div100');
    },
    clearAnimation: function () {
        this.ui.htmlSingle.removeClass().addClass('htmlSingle');
        this.ui.htmlSingle.addClass('div100');
        this.ui.htmlSingle.css('display', 'none');
    },
    setupSetting() {
        this.setupMargin();

        var animation = this.app.entities.collections.HtmlSlideAnimation.where({ Value: this.model.attributes.Data.Collection[0].Animation })[0];
        this.setAnimation(animation.attributes.Css);
    },
    onAttach() {
        this.setupSetting();

        helper_infopage.setupCssStyle(this.app);

        var self = this;
        var nowLocalDate = new Date();
        this.editorClass = nowLocalDate.getFullYear().toString() +
            (nowLocalDate.getMonth() + 1).toString() +
            nowLocalDate.getDate().toString() +
            nowLocalDate.getHours().toString() +
            nowLocalDate.getMinutes().toString() +
            nowLocalDate.getSeconds().toString() +
            nowLocalDate.getMilliseconds().toString();

        this.ui.editor.addClass(this.editorClass);
        this.ui.editor.addClass('infopage');

        this.EditorElement = $('.' + this.editorClass)[0];

        var animation = self.app.entities.collections.HtmlSlideAnimation.where({ Value: self.model.attributes.Data.Collection[0].Animation })[0];

        var self = this;
        var fonts = ['Arial', 'Courier', 'Georgia', 'Monospace', 'Sans-serif', 'Serif'];

        self.app.entities.collections.Font.forEach(function (entry) {
            fonts.push(entry.attributes.data_font_family);
        });


        if (this.options.live) {
            this.ui.editor.html(self.model.attributes.Data.Collection[0].Data);
            this.setAnimation(animation.attributes.Css);
        }
        else if (InlineEditor != undefined) {
            var uploadurl = 'api/SimpleUpload/' + this.options.customEvent.attributes.id + '/' + config.authUserId();
            InlineEditor
                .create(this.EditorElement, {
                    //plugins: [Autosave],
                    //plugins: [SimpleUploadAdapter],
                    fontFamily: {
                        options: fonts,
                        supportAllValues: true
                    },
                    // toolbar: [ 'heading', '|', 'bold', 'italic', 'link' ],
                    //toolbar: ['headings', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote']
                    toolbar: {
                        items: [
                            'heading', '|',
                            'fontfamily', 'fontsize', '|',
                            'alignment:left', 'alignment:right', 'alignment:center', 'alignment:justify',
                            //'alignment', '|',
                            'fontColor', 'fontBackgroundColor', '|',
                            'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
                            'link', '|',
                            'outdent', 'indent', '|',
                            'bulletedList', 'numberedList', 'todoList', '|',
                            'code', 'codeBlock', '|',
                            'insertTable', '|',
                            'imageUpload', 'blockQuote', '|',
                            'undo', 'redo'
                        ],
                        shouldNotGroupWhenFull: true
                    },
                    Autosave: {
                        save(editor) {
                            // The saveData() function must return a promise
                            // which should be resolved when the data is successfully saved.
                            //return saveData(editor.getData());
                            alert("HER");

                            return true;
                        }
                    },
                    image: {
                        styles: [
                            'alignCenter',
                            'alignLeft',
                            'alignRight'
                        ],
                        resizeOptions: [
                            {
                                name: 'resizeImage:original',
                                label: 'Original',
                                value: null
                            },
                            {
                                name: 'resizeImage:50',
                                label: '50%',
                                value: '50'
                            },
                            {
                                name: 'resizeImage:75',
                                label: '75%',
                                value: '75'
                            }
                        ],
                        toolbar: [
                            'imageTextAlternative', 'toggleImageCaption', '|',
                            'imageStyle:inline', 'imageStyle:wrapText', 'imageStyle:breakText', 'imageStyle:side', '|',
                            'resizeImage'
                        ]

                    },
                    simpleUpload: {
                        // The URL that the images are uploaded to.
                        uploadUrl: uploadurl,

                        // Enable the XMLHttpRequest.withCredentials property.
                        withCredentials: true,

                        // Headers sent along with the XMLHttpRequest to the upload server.
                        headers: {
                            //'X-CSRF-TOKEN': 'CSRF-Token',
                            Authorization: "Bearer ".concat(window['user'].access_token)//'Bearer <JSON Web Token>'
                        }
                    }
                })
                .then(editor => {
                    self.ckeditor = editor;
                    editor.setData(self.model.attributes.Data.Collection[0].Data);
                    self.setAnimation(animation.attributes.Css);
                    $('.ck.ck-reset.ck-dropdown__panel.ck-dropdown__panel_se').css('max-height', '300px');
                    $('.ck.ck-reset.ck-dropdown__panel.ck-dropdown__panel_se').css('overflow', 'scroll');
                    self.ui.editor.attr('contenteditable', self.options.contenteditable);
                })
                .catch(err => {
                    //console.error(err.stack);
                });
        }
    },
    myDestroy() {
        if (!this.options.live) {
            //this.ckeditor.destroy();
            //if (CKEDITOR.instances.myInstanceName) CKEDITOR.instances.myInstanceName.destroy();
        }
    }
}, Backbone.Radio.Requests);
